import { render, staticRenderFns } from "./OldPixelStreamer.vue?vue&type=template&id=a53cbccc&scoped=true&"
import script from "./OldPixelStreamer.vue?vue&type=script&lang=js&"
export * from "./OldPixelStreamer.vue?vue&type=script&lang=js&"
import style0 from "./OldPixelStreamer.vue?vue&type=style&index=0&id=a53cbccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53cbccc",
  null
  
)

export default component.exports